import { handleOnConnect, handleHMR } from 'irmlib/virtusa-redux'
import { setLocale, fallbackLanguageCode } from 'irmlib/multilanguage'

import { userRoleAdmin, userRoleUser, userRoleSupervisor } from '../common/constants'
import { edgeAIBase } from '../navigation/routePaths'
import * as constants from 'irmlib/common/constants'
import * as gdeTrancactions from '../services/firestore/gdeTransactions'
const reducerKey = 'reduxGlobal'

const isMockUser = false
const isMockSupervisor = false

// eslint-disable-next-line no-unused-vars
const mockUserUser = {
  role: userRoleUser,
  name: 'User Name',
  email: 'uname@ironmountain.com',
  district: 'A-ATLANTA',
  workerId: '0100002'
}

// eslint-disable-next-line no-unused-vars
const mockAdminUser = {
  role: userRoleAdmin,
  name: 'Admin Name',
  email: 'AdminName@ironmountain.com',
  district: 'A-ATLANTA',
  workerId: '0100002'
}

const mockSupervisor = {
  role: userRoleSupervisor,
  name: 'Supervisor Name',
  email: 'SupervisorName@ironmountain.com',
  district: 'A-ATLANTA',
  workerId: '0100002'
}

const mockNotifications = [
  /*
  'Notifications 1',
  'Notifications 2',
  'Notifications 3',
  'Notifications 4',
  'Notifications 5',
  'Notifications 6',
  'Notifications 7',
  'Notifications 8',
  'Notifications 9',
  'Notifications 10',
  */
]

const initialState = {
  renderSideBarTreeView: false,
  languageCode: fallbackLanguageCode,
  // Note: this must be initialized to {} once login is in place and connected to the backend.
  user: isMockUser ? mockUserUser : isMockSupervisor ? mockSupervisor : mockAdminUser,
  notifications: mockNotifications,
  dashBoardLinkOn: true,
  loggedIn: false,
  clickedDashboard: 0,
  currentPath: '',
  multi_tab: false
}

let { setState, getState, reducerState } = handleHMR(module, initialState)
/**
 * Callback for useConnect for the component. Sets of the redux machinery for the component.
 * 
 * @param {object} store - Redux store
 * @returns {void} Nothing
 */
export function initReduxGlobal(store) {
  ({ setState, getState, reducerState } = handleOnConnect(store, { reducerKey, initialState }))
}

/**
 * Set redux global to its initial state.
 */
export const clearReduxGlobal = () => {
  setState(initialState)
}

/**
 * Updates multiple global redux data simultaneously. Redux is slow. So many individual updates can take seconds. 
 *
 * @param {object} obj data to update.
 */
export const mergeReduxGlobalData = obj => {
  setState(obj)
}

export const triggerRenderSideBarTreeView = () => {
  setState({ renderSideBarTreeView: !getState().renderSideBarTreeView })
}

export const renderSideBarTreeViewSelector = () =>
  getState().renderSideBarTreeView

/**
 * Callback for the redux useSelector.
 * 
 * @returns {object} - The keys and associated data at the reducer key for locale.  
 */
export const languageSelectors = () => {
  const reducerKeyState = getState()
  return {
    languageCode: reducerKeyState.languageCode
  }
}

/**
 * Changes the language.
 *
 * @param {string} languageCode - the language to change to.
 * @returns {void} Nothing
 */
export const changeLocale = async (languageCode) => {
  await setLocale(languageCode)
  reducerState.languageCode = languageCode
}

export let indexOfviewAllJobs = -1
export let indexOfAssignJob = -1
export let indexOfQualityCheck = -1
export let indexOfManuallTransmitJob = -1
export let indexOfViewProductivityReport = -1
export let indexOfSearchTemplate = -1
export let indexOfCreateJob = -1
export let indexOfEditJob = -1
export let indexOfCreateTemplate = -1
export let indexOfLocalAI = -1
export let indexOfConfiguration = -1
export let indexOfManageExclusions = -1


export const setUser = async(user) => {
  const workerDetailsGde = await gdeTrancactions.getGdeWorkerDetails(user.workerId)
  const rawDataGde = workerDetailsGde.data()

  window.sessionStorage.setItem('additional-permissions-user', JSON.stringify(rawDataGde.additionalPermissions))
  window.sessionStorage.setItem('customerLevelReportDisplayColumnsId', rawDataGde?.customerLevelReportDisplayColumnsId)  
  const additionalGivenPermissions = window.sessionStorage.getItem('additional-permissions-user')
  
  if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined) {
    const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
    indexOfviewAllJobs = additionalPermissionsForUser.map(object => object.value).indexOf('viewAllJobs')
    indexOfAssignJob = additionalPermissionsForUser.map(object => object.value).indexOf('assignJob')
    indexOfQualityCheck = additionalPermissionsForUser.map(object => object.value).indexOf('qualityCheck')
    indexOfManuallTransmitJob = additionalPermissionsForUser.map(object => object.value).indexOf('manuallyTransmitJob')
    indexOfViewProductivityReport = additionalPermissionsForUser.map(object => object.value).indexOf('viewProductivityReport')
    indexOfSearchTemplate = additionalPermissionsForUser.map(object => object.value).indexOf('searchTemplate')
    indexOfCreateJob = additionalPermissionsForUser.map(object => object.value).indexOf('createJob')
    // specifically for local AI and Configuration role addtional permission
    indexOfLocalAI = additionalPermissionsForUser.map(object => object.value).indexOf('localAI')
    indexOfConfiguration = additionalPermissionsForUser.map(object => object.value).indexOf('configuration')
    indexOfManageExclusions = additionalPermissionsForUser.map(object => object.value).indexOf('manageExclusions')

    // for supervisor
    indexOfEditJob = additionalPermissionsForUser.map(object => object.value).indexOf('editJob')
    indexOfCreateTemplate = additionalPermissionsForUser.map(object => object.value).indexOf('createTemplate')
  }

  if (rawDataGde?.gdeCountryCode !== undefined) {
    user.countryCode = rawDataGde.gdeCountryCode
    user.country = rawDataGde.gdeCountry
  }
  setState({ user: { ...user }, loggedIn: true })
}

export const setMultiTab = () =>
  setState({ multi_tab: !getState().multi_tab })

export const getMultiTab = () =>
  getState().multi_tab


export const getUser = () =>
  getState().user

export const getUserRole = () =>
  getState().user.role

export const getUserName = () =>
  getState().user.name

export const getUserEmail = () =>
  getState().user.email

export const setCurrentPath = (path) =>
  setState({ currentPath: path })

export const getCurrentPath = () =>
  getState().currentPath
// Note you must use useSelector(getSlideoutInfo, shallowEqual) where import { useSelector, shallowEqual } from 'react-redux'
// for the below selector.
// The reason is without shallowEqual, the below will cause a render everytime because getSlideoutInfo returns a new object each time it is called.
// useSelector only checks for equality and so the object returned on each run is new thereby causing a render.
// Note this means a render is stimulated on EVERY state change not just the state changes to the ones in the below object.
export const getSlideoutInfo = () => {
  const state = getState()
  return {
    userRole: state.user.role,
    userName: state.user.name,
    userEmail: state.user.email,
  }
}

export const persistFilters = () => {
  const { workerId, district, country } = getUser()
  const pathParams = location.pathname.split('/')
  const isEdgeAIRoute = location.pathname.startsWith(edgeAIBase)
  const urlPathname = pathParams[1]
  const persistFiltersRaw = localStorage.getItem('persistFilters')
  let defDistricts = [district]
  let defStatuses = constants.defaultSelect
  let building
  let wmsInstance
  let wmsRegion

  if (persistFiltersRaw && persistFiltersRaw !== 'undefined') {
    const persistFilters = JSON.parse(persistFiltersRaw)
    const currentUrl = persistFilters?.[urlPathname]
    if (currentUrl && currentUrl !== 'undefined') {
      if (currentUrl.workerId === workerId && currentUrl.country === country) {
        defDistricts = currentUrl.district
        defStatuses = currentUrl.status
        building = currentUrl.building
        wmsInstance = currentUrl.wmsInstance
        wmsRegion = currentUrl.wmsRegion
      } else {
        localStorage.removeItem('persistFilters')
      }
    } 
  }
  return {
    district: defDistricts,
    status: defStatuses,
    building: building,
    wmsInstance: wmsInstance,
    wmsRegion: wmsRegion,
  }
}


export const getAppHeaderInfo = () => {
  const state = getState()
  return {
    numNotifications: state.notifications.length,
  }
}

export const isLoggedIn = () =>
  getState().loggedIn

export const setSkpApiJWT = val =>
  reducerState.skpApiJWT = val

export const getSkpApiJWT = () =>
  reducerState.skpApiJWT 

export const mockLogin = () =>
  isMockUser ? mockUserUser : isMockSupervisor ? mockSupervisor : mockAdminUser

export const turnOffDashBoardLink = () =>
  setState({ dashBoardLinkOn: false })

export const turnOnDashBoardLink = () =>
  setState({ dashBoardLinkOn: true })

export const getDashBoardLinkOn = () =>
  getState().dashBoardLinkOn

export const clickedDashboard = () =>
  setState({ clickedDashboard: getState().clickedDashboard + 1 })

export const getClickedDashboard = () =>
  getState().clickedDashboard